import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "../../../entities/vehicleEquipment/api/api.js";
import { useGetVehiclesOptionGroups } from "../../../entities/vehicleEquipment/lib/useGetVehiclesOptionGroups.js";
import { useGetVehiclesSpecificationGroups } from "../../../entities/vehicleEquipment/lib/useGetVehiclesSpecificationGroups.js";
import { useGetVehiclesSpecifications } from "../../../entities/vehicleEquipment/lib/useGetVehiclesSpecifications.js";
import "../../../entities/vehicleEquipment/model/selectors/selectOptionGroupsParameters.js";
import "../../../entities/vehicleEquipment/model/selectors/selectSpecificationGroupsParameters.js";
import "../../../entities/vehicleEquipment/model/selectors/selectSpecificationsParameters.js";
import "react-router";
import "@perxis-auto/shared";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { selectors } from "../../../features/comparison/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import { useGetComparableVehicles } from "../../../features/comparison/lib/useGetComparableVehicles.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/ui-kit";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
import { formatOptions } from "../lib/formatOptions.js";
import { formatSpecifications } from "../lib/formatSpecifications.js";
import { Item } from "../ui/item/Item.js";
const COMPARISON_EQUIPMENT_SECTIONS = [
  {
    path: "options",
    title: "widgets.comparisonEquipments.options"
  },
  {
    path: "specifications",
    title: "widgets.comparisonEquipments.specifications"
  }
];
const useContainer = (item) => {
  const props = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { t } = useTranslation(APP.name);
  const {
    preparedData: { selectedComparableVehicles = [] }
  } = useGetComparableVehicles();
  const {
    preparedData: { optionGroupsMap }
  } = useGetVehiclesOptionGroups();
  const {
    preparedData: { specificationGroupsMap }
  } = useGetVehiclesSpecificationGroups();
  const {
    preparedData: { specificationsMap }
  } = useGetVehiclesSpecifications();
  const isShowDifference = useAppSelector(selectors.selectIsShowDifference);
  const comparedOptions = useMemo(() => {
    if (!optionGroupsMap) {
      return;
    }
    const optionsMatrix = selectedComparableVehicles.map((car) => car.data.options || []);
    const formattedOptions = formatOptions(
      { optionsMatrix, optionGroupsMap },
      {
        onlyDifferences: isShowDifference
      }
    );
    return formattedOptions;
  }, [isShowDifference, optionGroupsMap, selectedComparableVehicles]);
  const comparedSpecificationValues = useMemo(() => {
    if (!specificationsMap || !specificationGroupsMap) {
      return;
    }
    const specificationValuesMatrix = selectedComparableVehicles.map((car) => car.data.specificationsValues || []);
    const formattedSpecificationValues = formatSpecifications(
      {
        specificationValuesMatrix,
        specificationsMap,
        specificationGroupsMap
      },
      { onlyDifferences: isShowDifference }
    );
    return formattedSpecificationValues;
  }, [isShowDifference, selectedComparableVehicles, specificationGroupsMap, specificationsMap]);
  const comparisonEquipmentTabs = useMemo(() => {
    const tabs = [];
    if (comparedOptions == null ? void 0 : comparedOptions.length) {
      tabs.push({
        key: COMPARISON_EQUIPMENT_SECTIONS[0].path,
        label: t(COMPARISON_EQUIPMENT_SECTIONS[0].title),
        children: /* @__PURE__ */ jsx(Item, { showIcon: true, groups: comparedOptions })
      });
    }
    if (comparedSpecificationValues == null ? void 0 : comparedSpecificationValues.length) {
      tabs.push({
        key: COMPARISON_EQUIPMENT_SECTIONS[1].path,
        label: t(COMPARISON_EQUIPMENT_SECTIONS[1].title),
        children: /* @__PURE__ */ jsx(Item, { groups: comparedSpecificationValues })
      });
    }
    return tabs;
  }, [comparedOptions, comparedSpecificationValues, t]);
  return {
    ...props,
    items: comparisonEquipmentTabs
  };
};
export {
  useContainer
};
